<template>
  <div>
    <h1 class="font-semibold text-xl mb-5 flex justify-between items-center">
      <div>
        {{ (product && product.name) || "Создать продукт" }}
        <i v-if="loading" class="el-icon-loading"></i>
      </div>
      <div>
        <el-button
          @click="() => $router.back()"
          size="small"
          icon="el-icon-back"
          round
        >
          Назад
        </el-button>
        <el-button
          @click="deleteProduct"
          v-if="product_id !== 'new'"
          size="small"
          plain
          round
          type="danger"
        >
          Удалить
        </el-button>
        <el-button plain round type="primary" size="small" @click="saveProduct">
          Сохранить
        </el-button>
      </div>
    </h1>

    <el-row>
      <el-col :span="10">
        <el-form label-position="top">
          <div class="mb-5 rounded-md">
            <div class="mb-3">
              <p class="text-gray-500 mb-1">Магазин</p>
              <el-select v-model="product.shop_id" filterable class="w-full">
                <el-option
                  v-for="c in shops"
                  :key="c.id"
                  :value="c.id"
                  :label="c.company"
                ></el-option>
              </el-select>
            </div>

            <div class="mb-3">
              <p class="text-gray-500 mb-1">Только с этого пункта</p>
              <el-input clearable v-model="product.pp"></el-input>
            </div>

            <div class="mb-3">
              <p class="text-gray-500 mb-1">Снято с продажи</p>
              <el-checkbox
                v-model="product.status"
                :true-label="-1"
                :false-label="0"
              ></el-checkbox>
            </div>
            <el-row :gutter="20">
              <el-col :span="16">
                <div class="mb-3">
                  <p class="text-gray-500 mb-1">Категория</p>
                  <el-select
                    v-model="product.category_id"
                    filterable
                    class="w-full"
                    clearable
                  >
                    <el-option
                      v-for="c in categories"
                      :key="c.id"
                      :value="c.id"
                      :label="c.name"
                    >
                      <div class="flex items-center">
                        <el-image
                          v-if="c.photo"
                          :src="`${$options.domain}/${c.photo}`"
                          class="w-7 h-7 rounded-md border border-gray-200 border-solid mr-3"
                        ></el-image>
                        <span class="">{{ c.name }}</span>
                      </div>
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="mb-3">
                  <p class="text-gray-500 mb-1">Бренд</p>
                  <el-input v-model="product.brand"></el-input>
                </div>
              </el-col>
            </el-row>

            <div class="mb-3">
              <p class="text-gray-500 mb-1">Название</p>
              <el-input v-model="product.name"></el-input>
            </div>

            <div class="mb-3">
              <p class="text-gray-500 mb-1">Поставщик работает в субботу</p>
              <el-checkbox v-model="product.saturday"></el-checkbox>
            </div>

            <el-row :gutter="20">
              <el-col :span="12">
                <div class="mb-3">
                  <p class="text-gray-500 mb-1">Гарантия</p>
                  <el-input v-model="product.guarantee_period"></el-input>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="mb-3">
                  <p class="text-gray-500 mb-1">Средняя цена</p>
                  <el-input v-model="average_price" disabled></el-input>
                </div>
              </el-col>
            </el-row>

            <div class="mb-3">
              <p class="text-gray-500 mb-1">Скидка, %</p>
              <el-input-number
                v-model="product.discount"
                :min="0"
                :max="100"
                :step="1"
                controls-position="right"
                class="w-full"
              ></el-input-number>
              <p v-if="brand_discount > 0" class="text-gray-500 text-xs mt-1">
                У бренда {{ product.brand }} скидка {{ brand_discount }}%
                <template v-if="!product.discount"
                  >— она и применится, пока здесь 0.</template
                >
                <template v-else
                  >— скидка товара главнее, применится
                  {{ product.discount }}%.</template
                >
                <router-link :to="{ name: 'brands' }" class="text-blue-500">
                  Бренды
                </router-link>
              </p>
            </div>
          </div>

          <div class="mb-5 mt-5 p-4 border border-gray-200 rounded-md">
            <p class="font-semibold text-sm mb-3">Лендинг</p>

            <div class="mb-3">
              <p class="text-gray-500 mb-1">Лендинг</p>
              <el-select v-model="product.landing" clearable class="w-full" placeholder="Не выбран" @change="onLandingChange">
                <el-option label="aircond" value="aircond"></el-option>
                <el-option label="almacom" value="almacom"></el-option>
              </el-select>
            </div>

            <div class="mb-3" v-if="product.landing">
              <p class="text-gray-500 mb-1">Режим цены</p>
              <el-select v-model="product.landing_price_mode" clearable class="w-full" placeholder="Не выбран">
                <el-option label="Статичная цена" value="static"></el-option>
                <el-option label="Средняя цена + %" value="avg_markup"></el-option>
                <el-option label="Мин цена модификатора + %" value="min_modifier_markup"></el-option>
              </el-select>
            </div>

            <div class="mb-3" v-if="product.landing_price_mode === 'static'">
              <p class="text-gray-500 mb-1">Цена (статичная)</p>
              <el-input v-model.number="product.landing_static_price" type="number" placeholder="0"></el-input>
            </div>

            <div class="mb-3" v-if="product.landing_price_mode === 'avg_markup' || product.landing_price_mode === 'min_modifier_markup'">
              <p class="text-gray-500 mb-1">Наценка %</p>
              <el-input v-model.number="product.landing_markup" type="number" placeholder="0"></el-input>
            </div>

            <div class="mb-3" v-if="product.landing">
              <p class="text-gray-500 mb-1">Тип кондиционера</p>
              <el-select v-model="product.landing_type" clearable class="w-full" placeholder="Не указан">
                <el-option label="Инвертор" value="inverter"></el-option>
                <el-option label="On/Off" value="onoff"></el-option>
              </el-select>
            </div>

            <div class="mb-3" v-if="product.landing">
              <p class="text-gray-500 mb-1">Площадь помещения (м²)</p>
              <el-input v-model.number="product.landing_area" type="number" placeholder="Например: 25"></el-input>
            </div>
          </div>

          <div v-if="false" class="mb-3">
            <p class="text-gray-500 mb-1">Фото</p>
            <el-upload
              :action="uploadUri"
              :headers="headers"
              :on-success="handlePhotoUploadSuccess"
              :data="{ type: 'image' }"
              :show-file-list="false"
            >
              <el-button size="small" type="primary" plain>Загрузить</el-button>
            </el-upload>
            <ul v-if="product.images.length > 0" class="product-images">
              <li v-for="image in product.images" :key="image.url">
                <img :src="`${$options.domain}/${image.url}`" alt="" class="" />

                <div @click="removeImage(image.url)" class="remove-button">
                  <i class="el-icon-delete"></i>
                </div>
              </li>
            </ul>
          </div>

          <div
            v-if="searchSku"
            class="mt-3 p-4 border border-gray-200 rounded-md bg-gray-50"
          >
            <div class="">
              <div class="flex items-center gap-2">
                <el-input
                  v-model="searchSku"
                  placeholder="Поиск по SKU"
                  clearable
                ></el-input>
                <el-button
                  @click="parseProductData"
                  type="primary"
                  plain
                  :loading="parseLoading"
                  :disabled="parseLoading"
                >
                  Парсить
                </el-button>
              </div>
            </div>

            <div v-if="store" class="mt-3">
              <div class="text-sm font-semibold">{{ store.title }}</div>
              <ul class="mt-2 flex flex-wrap gap-1">
                <li
                  v-for="image in store.images"
                  :key="image"
                  class="w-20 h-20 rounded-md border border-gray-200 border-solid relative overflow-hidden"
                >
                  <img
                    :src="'https://resources.cdn-kaspi.kz/img/m/p/' + image"
                    class="w-full h-full object-cover"
                  />
                </li>
              </ul>
              <div v-if="Object.keys(store.features).length > 0">
                <div
                  v-for="(features, groupName) in store.features"
                  :key="groupName"
                  class="mt-3"
                >
                  <div class="text-sm font-semibold">
                    {{ groupName }}
                  </div>
                  <div
                    v-for="feature in features"
                    :key="feature.id"
                    class="mt-1 flex justify-between text-xs"
                  >
                    <div class="">
                      {{ feature.name }}
                    </div>
                    <div class="text-gray-500">
                      {{ feature.value }}
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="store.description" class="mt-3">
                <div class="text-sm font-semibold mb-1">Описание</div>
                <div
                  class="text-xs text-gray-500"
                  v-html="store.description"
                ></div>
              </div>
            </div>
          </div>
        </el-form>
      </el-col>
      <el-col :span="12" :offset="2">
        <template v-if="product_id !== 'new'">
          <product-modificators
            @set:default:modification="(sku) => (searchSku = sku)"
          />

          <pre-order-settings></pre-order-settings>

          <h1
            class="font-semibold text-xl mt-5 mb-2 flex justify-between items-center"
          >
            <div>Доступность</div>
          </h1>
          <el-table border size="small" :data="storage">
            <el-table-column type="index" label="N"></el-table-column>
            <el-table-column
              prop="warehouse_name"
              label="Склад"
            ></el-table-column>
            <el-table-column prop="count" label="Кол-во"></el-table-column>
            <el-table-column
              prop="pre_order"
              label="Предзаказ"
            ></el-table-column>
          </el-table>

          <h1
            class="font-semibold text-xl mt-5 mb-2 flex justify-between items-center"
          >
            <div>Уходы и приходы</div>
          </h1>
          <el-table border size="small" :data="accountings">
            <el-table-column type="index" label="N"></el-table-column>
            <el-table-column prop="created_at" label="Документ">
              <template v-slot="scope">
                <router-link
                  target="_blank"
                  class="text-blue-500"
                  :to="{
                    name: 'accounting-item',
                    params: { id: scope.row.id },
                  }"
                >
                  {{ scope.row.basis }}
                </router-link>
              </template>
            </el-table-column>
            <el-table-column
              prop="warehouse_name"
              label="Склад"
            ></el-table-column>
            <el-table-column prop="created_at" label="Создано">
              <template v-slot="scope">
                {{ dateTimeFormat(scope.row.created_at2) }}
              </template>
            </el-table-column>
            <el-table-column prop="total_price" label="Сумма">
            </el-table-column>
            <el-table-column prop="order_status" label="Статус">
              <template slot-scope="scope">
                {{ scope.row.order_state }} <br />
                {{ scope.row.order_status }}
              </template>
            </el-table-column>
            <el-table-column prop="type" label="Тип">
              <template v-slot="scope">
                <i
                  v-if="
                    problem_accounting_ids.includes(scope.row.id) ||
                    scope.row.pre_order > 0
                  "
                  class="el-icon-warning text-red-500 mr-2"
                ></i>

                <el-tag
                  size="mini"
                  :type="getStateOfAccounting(scope.row).type"
                >
                  {{ getStateOfAccounting(scope.row).label }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  getProduct,
  createProduct,
  updateProduct,
  deleteProduct,
} from "@/api/product";
import { getShops } from "@/api/branch";
import { getCategories } from "@/api/category";
import { dateTimeFormat } from "@/helpers/formatter";
import { getOrderStatus } from "@/helpers/order-status";
import PreOrderSettings from "@/views/Products/shared/components/PreOrderSettings.vue";
import ProductModificators from "@/views/Products/shared/components/ProductModificators.vue";
import LocalStorageService from "@/services/LocalStorageService";
import axios from "axios";
const localStorageService = LocalStorageService.getService();

export default {
  name: "Product",
  components: { ProductModificators, PreOrderSettings },
  domain: process.env.VUE_APP_DOMAIN,
  data: () => ({
    average_price: null,
    product: {
      name: null,
      brand: null,
      category_id: null,
      saturday: false,
      status: 0,
      guarantee_period: null,
      pp: null,
      shop_id: 2,
      discount: 0,
      images: [],
      landing: null,
      landing_price_mode: null,
      landing_static_price: null,
      landing_markup: null,
      landing_type: null,
      landing_area: null,
    },
    categories: [],
    modifications: [],
    storage: [],
    shops: [],
    accountings: [],
    problem_accounting_ids: [],
    modification: { sku: null, sku_kaspi: null },
    loading: false,
    dialogVisible: false,

    searchSku: null,
    parseLoading: false,

    store: null,
    brand_discount: 0,
  }),
  computed: {
    product_id() {
      return this.$route.params.id;
    },
    user() {
      return this.$store.state.user;
    },
    uploadUri() {
      return `${process.env.VUE_APP_DOMAIN}/api/upload`;
    },
    headers() {
      const token = localStorageService.getAccessToken();
      return { Authorization: `Bearer ${token}` };
    },
  },
  async created() {
    this.categories = await getCategories();
    this.shops = await getShops();
    if (this.product_id !== "new") {
      this.loading = true;
      const serverData = await getProduct(this.product_id);
      const {
        name,
        brand,
        category_id,
        saturday,
        status,
        guarantee_period,
        pp,
        shop_id,
        discount,
        images,
        landing,
        landing_price_mode,
        landing_static_price,
        landing_markup,
        landing_type,
        landing_area,
      } = serverData.product;
      this.product = {
        name,
        brand,
        category_id,
        saturday,
        status,
        guarantee_period,
        pp,
        shop_id,
        discount: discount || 0,
        images,
        landing,
        landing_price_mode,
        landing_static_price,
        landing_markup,
        landing_type,
        landing_area,
      };
      this.storage = serverData.storage;
      this.average_price = serverData.average_price;
      this.accountings = serverData.accountings;
      this.problem_accounting_ids = serverData.problem_accounting_ids;
      this.store = serverData.store;
      this.brand_discount = serverData.brand_discount || 0;
      this.loading = false;
    }
  },
  methods: {
    onLandingChange(val) {
      if (!val) {
        this.product.landing_price_mode = null;
        this.product.landing_static_price = null;
        this.product.landing_markup = null;
        this.product.landing_type = null;
        this.product.landing_area = null;
      }
    },

    async saveProduct() {
      if (this.product_id === "new") {
        await this.createProduct();
      } else {
        await this.updateProduct();
      }
    },

    async parseProductData() {
      this.parseLoading = true;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_DOMAIN}/api/product/${this.product_id}/parser?kaspiSku=${this.searchSku}`
        );
        if (response.data.success && response.data.product) {
          this.$message.success("Успешно, обновите страницу");
        } else {
          this.$message.error("Ошибка при парсинге");
        }
      } catch (e) {
        this.$message.error(`Ошибка ${e.message}`);
      } finally {
        this.parseLoading = false;
      }
    },

    async deleteProduct() {
      try {
        this.loading = true;
        const result = await deleteProduct(this.product_id);
        if (result.success) {
          this.$message.success("Успешно");
          this.$router.back();
        } else {
          this.$message.error(`Ошибка ${result.message}`);
        }
      } catch (e) {
        this.$message.error(`Ошибка ${e.message}`);
      }
      this.loading = false;
    },

    async createProduct() {
      try {
        this.loading = true;
        const result = await createProduct({ ...this.product });
        if (result.success) {
          this.$message.success("Успешно");
          await this.$router.replace({ params: { id: result.product_id } });
          setTimeout(() => {
            location.reload();
          }, 1000);
        } else {
          this.$message.error(`Ошибка ${result.message}`);
        }
      } catch (e) {
        this.$message.error(`Ошибка ${e.message}`);
      }
      this.loading = false;
    },

    async updateProduct() {
      try {
        this.loading = true;
        const result = await updateProduct(this.product_id, {
          ...this.product,
        });
        if (result.success) {
          this.$message.success("Успешно");
        } else {
          this.$message.error(`Ошибка ${result.message}`);
        }
      } catch (e) {
        this.$message.error(`Ошибка ${e.message}`);
      }
      this.loading = false;
    },

    dateTimeFormat(timestamp) {
      return dateTimeFormat(timestamp * 1000);
    },
    getStateOfAccounting(acc) {
      return getOrderStatus(acc);
    },
    handlePhotoUploadSuccess(response) {
      this.product.images.push({
        url: response.url,
        is_main: false,
      });
    },
    removeImage(url) {
      this.product.images = this.product.images.filter(
        (image) => image.url !== url
      );
    },
  },
};
</script>

<style scoped lang="scss">
.product-images {
  @apply mt-5;
  li {
    @apply w-20 h-20 rounded-md border border-gray-200 border-solid relative overflow-hidden;
    img {
      @apply w-full h-full object-cover;
    }
    .remove-button {
      @apply w-5 h-5 flex items-center justify-center absolute bottom-1 right-1 bg-transparent text-white rounded;
      @apply cursor-pointer;
      i {
        @apply text-red-500;
      }

      &:hover {
        @apply bg-red-100;
      }
    }
  }
}
</style>
